// Gestione accordion per sezioni nella descrizione prodotto
document.addEventListener("DOMContentLoaded", function () {
  const productDescription = document.querySelector('.product-info__block-item[data-block-id="description"] .prose');

  if (productDescription) {
    const regex = /<p><strong>Material\s*&amp;\s*Care:<br><\/strong>(.*?)<\/p>/is;
    const match = productDescription.innerHTML.match(regex);
    
    if (match) {
      const contentOnly = match[1].trim(); // Testo senza il titolo
      const accordionHTML = `
        <div class="material-care-accordion">
          <div class="material-care-title">Material & Care</div>
          <div class="material-care-content" style="display: none;">
            <p>${contentOnly}</p>
          </div>
        </div>
      `;

      // Sostituisci solo il paragrafo originale con l'accordion
      productDescription.innerHTML = productDescription.innerHTML.replace(match[0], accordionHTML);


      // Aggiungi evento click per aprire/chiudere l'accordion
      document.querySelector(".material-care-title").addEventListener("click", function () {
        const content = this.nextElementSibling;
        content.style.display = content.style.display === "block" ? "none" : "block";
        this.classList.toggle("active");
      });
    }
  }
});

